import { Link } from '@backstage/core-components';
import React from 'react';

function isValidUrl(url) {
  return Boolean(url && url !== "#" && url.length > 0);
}
const WithLink = ({
  url,
  className,
  children
}) => isValidUrl(url) ? /* @__PURE__ */ React.createElement(Link, { className, to: url }, children) : /* @__PURE__ */ React.createElement(React.Fragment, null, children);

export { WithLink, isValidUrl };
//# sourceMappingURL=components.esm.js.map
